import cloneDeep from 'lodash/cloneDeep';
import { merge } from '@/utils/index.js';

export default {
    render() {
        return null;
    },

    props: {
        filters: {
            type: Object,
            required: true,
        },
    },

    watch: {
        filters: {
            deep: true,
            handler() {
                this.updateQuery();
            },
        },
    },

    methods: {
        updateQuery() {
            const newQuery = cloneDeep(this.filters);

            Object.keys(newQuery).forEach(key => {
                if (!newQuery[key]) {
                    delete newQuery[key];
                }
            });

            this.$router.replace({
                ...this.$route,
                query: newQuery,
            }).catch(() => {});
        },

        setInitialFilters() {
            const updatedFilters = merge(this.filters, this.$route.query);

            this.$emit('update:filters', updatedFilters);
        },
    },

    created() {
        this.setInitialFilters();
    },

    mounted() {
        this.$nextTick(() => {
            this.updateQuery();
        });
    },
};
